var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor whatsapp-business-message" },
    [
      _c(
        "a-spin",
        { staticClass: "spinner", attrs: { spinning: _vm.loading } },
        [
          _c(
            "div",
            { staticClass: "editor-row" },
            [
              _c("div", { staticClass: "editor-row-title" }, [
                _vm._v("Channel"),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticClass: "classic-new-select",
                  attrs: { placeholder: "Whatsapp Business Channel" },
                  model: {
                    value: _vm.clone.channelId,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "channelId", $$v)
                    },
                    expression: "clone.channelId",
                  },
                },
                _vm._l(_vm.businessChannels, function (channel) {
                  return _c(
                    "a-select-option",
                    { key: channel._id, attrs: { value: channel._id } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(channel.name) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.clone.channelId
            ? _c(
                "div",
                { staticClass: "editor-row" },
                [
                  _c("div", { staticClass: "editor-row-title" }, [
                    _vm._v("\n                Template\n                "),
                    _c(
                      "div",
                      {
                        staticClass: "material-icons",
                        on: {
                          click: function ($event) {
                            _vm.previewMode = true
                          },
                        },
                      },
                      [_vm._v("visibility")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticClass: "classic-new-select",
                      attrs: {
                        placeholder: "Whatsapp Business Channel",
                        value: _vm.selectedTemplateId,
                      },
                      on: { change: _vm.selectTemplate },
                    },
                    _vm._l(_vm.templates, function (template) {
                      return _c(
                        "a-select-option",
                        { key: template.id, attrs: { value: template.id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(template.elementName) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedTemplateId
            ? _c(
                "div",
                { staticClass: "editor-row" },
                [
                  _c("div", { staticClass: "editor-row-title" }, [
                    _vm._v("Phone Number"),
                  ]),
                  _vm._v(" "),
                  _c("TiptapEditor", {
                    attrs: {
                      placeholder: "Phone Number",
                      "show-attributes": true,
                      "max-character-count": 500,
                    },
                    model: {
                      value: _vm.clone.phoneNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "phoneNumber", $$v)
                      },
                      expression: "clone.phoneNumber",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedTemplateId && _vm.variables.length > 0
            ? _c(
                "div",
                { staticClass: "wpa-variables" },
                _vm._l(_vm.variables, function (variable, index) {
                  return _c(
                    "div",
                    { staticClass: "editor-row" },
                    [
                      _c("div", { staticClass: "editor-row-title" }, [
                        _vm._v("Variable (#" + _vm._s(index + 1) + ")"),
                      ]),
                      _vm._v(" "),
                      _c("TiptapEditor", {
                        attrs: {
                          placeholder: "Variable (#" + (index + 1) + ")",
                          "show-attributes": true,
                          "max-character-count": 500,
                          value: _vm.getVariableValue(index),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.setVariableValue(index, $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.clone.template &&
          ["IMAGE", "VIDEO", "DOCUMENT"].includes(
            _vm.clone.template.templateType
          )
            ? _c("div", { staticClass: "image-picker" }, [
                _vm.useDefault
                  ? _c("div", { staticClass: "editor-row" })
                  : _c("div", { staticClass: "editor-row" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                              },
                              expression:
                                "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                            },
                          ],
                          staticClass: "editor-row-title",
                          attrs: {
                            content: "Görseli Özelleştirmek İstiyorsanız.",
                          },
                        },
                        [
                          _vm._v(
                            "\n                    Media\n                    "
                          ),
                          _c("span", { staticClass: "optional" }, [
                            _vm._v(
                              _vm._s(_vm.$t("whatsapp_business_api.optional"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("a-icon", { attrs: { type: "question-circle" } }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.media
                        ? _c("div", { staticClass: "media-preview" }, [
                            _c(
                              "div",
                              { staticClass: "media-preview-content" },
                              [
                                _c("div", { staticClass: "media-image" }, [
                                  _c("img", {
                                    attrs: { src: _vm.media.data, alt: "" },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "media-preview-name" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.media.name) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "media-preview-delete",
                                on: { click: _vm.deleteMedia },
                              },
                              [
                                _c("div", { staticClass: "material-icons" }, [
                                  _vm._v("delete"),
                                ]),
                              ]
                            ),
                          ])
                        : _c("div", { staticClass: "media-drag" }, [
                            _c("div", { staticClass: "input" }, [
                              _c("input", {
                                attrs: {
                                  type: "file",
                                  id: "media-source",
                                  accept: _vm.getAcceptType(),
                                },
                                on: { change: _vm.handleFileUpload },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("image"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _vm._v("Click here to upload a picture."),
                            ]),
                          ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "description" }, [
                        _c("div", { staticClass: "input-warn" }, [
                          _c("div", [
                            _c("b", [_vm._v("Note:")]),
                            _vm._v(
                              "Following are the file formats and their respective sizes which are accepted\n                            for upload\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("ul", { staticClass: "list-item" }, [
                            _c("li", [
                              _vm._v("Image: JPEG and PNG (Max size 2 MB)"),
                            ]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Video: MP4 (Max size 20 MB)")]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Document: (Max size 2 MB)")]),
                          ]),
                        ]),
                      ]),
                    ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.clone.template
        ? _c("WhatsappMessagePreview", {
            attrs: {
              body: _vm.getTemplateParameters(_vm.clone.template).body,
              footer: _vm.getTemplateParameters(_vm.clone.template).footer,
              "header-media-type": _vm.getTemplateParameters(_vm.clone.template)
                .headerType,
              "header-text": _vm.getTemplateParameters(_vm.clone.template)
                .headerText,
              buttons: _vm.getTemplateParameters(_vm.clone.template).buttons,
              headerMediaURL: _vm.getTemplateParameters(_vm.clone.template)
                .headerMediaURL,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }